import { Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'empathy-ranks-form',
  templateUrl: './ranks-form.component.html',
  styleUrls: ['./ranks-form.component.scss']
})
export class RanksFormComponent {
  question = input<AbstractControl>();
  disabled = input<boolean>();
}
